import { getProtectedInstance } from "../utils/axiosInstance";

// ALL USER
export const allUserService = async () => {
  const response = await getProtectedInstance().get("/user");
  const aldata = await response.data.data;
  return aldata;
};

//SINGLE USER
export const individualUserService = async (id: string) => {
  const response = await getProtectedInstance().get(`/user?user_id=${id}`);
  const aldata = await response.data.data.data;
  return aldata;
};

// POST USER
export const postUserDataService = async (body: any) => {
  const response = await getProtectedInstance().post("/user", body);
  const aldata = await response.data;
  return aldata;
};
// POST Bulk Employee
export const postBulkEmpService = async (body: any) => {
  const response = await getProtectedInstance().post("/user/bulk", body);
  const aldata = await response.data;
  return aldata;
};

// SPECIFIC USER SERVICE
export const userSpecificService = async () => {
  // console.log("loginservice",token)
  const response = await getProtectedInstance().get("/user/me");
  const aldata = await response.data.data;
  return aldata;
};

//UPDATE USER
export const patchUserDataService = async (id: string, body: any) => {
  const response = await getProtectedInstance().patch(`/user/${id}`, body);
  const aldata = await response.data;
  return aldata;
};

//DELETE USER
export const deleteUserDataService = async (id: string) => {
  const response = await getProtectedInstance().delete(`/user/${id}`);
  const aldata = await response.data;
  return aldata;
};
